export default "__VITE_ASSET__CjnMmcjF__"